import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Label,
  FormGroup,
  FormFeedback,
  ModalFooter,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  fetchRfqReference,
  searchMaterialRequest,
  searchMaterialRequestFinance,
  searchRfq,
  updateAction,
  updateRfqAction,
  updateRfqReference,
  updateRfqUpdate,
  updateSupplierStatus,
} from "../../../services/procurement/materialrequest"
import moment from "moment"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import RfqFilter from "./filter"
import closeIcon from "../../../assets/icons/close.svg"
import { FormProvider, useForm } from "react-hook-form"
import { UFInput } from "../../../components/Common/Fields/Input"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import check from "../../../assets/icons/estimation_check.svg"
import { getCode } from "../../../services/inventory"
import { use } from "react"
import { R } from "@table-library/react-table-library/index-a318de9b"
import LogoutPopup from "../../../components/VerticalLayout/logoutpopup"

const RequestForQuote = ({ fromDashboard, projectId }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `RFQs${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))
  const desimalrange = localStorage.getItem("desimalrange")
  const [canvasOpen, setCanvasOpen] = useState(false)
  const [currentRfq, setCurrentRfq] = useState(null)
  const [description, setDescription] = useState("")
  const [itemStatus, setitemStatus] = useState()
  const [demoStatus, setDemoStatus] = useState()
  const [totalRefresh, setTotalRefresh] = useState(0)
  const [logoutModal, setLogoutModal] = useState(false)
  const [refData, setRefData] = useState({})
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const handleApproveWithDescription = async (item, id) => {
    setitemStatus(item?.status)
    if (id) {
      setDemoStatus(12)
    } else {
      setDemoStatus("")
    }
    console.log("jajjaj", item)

    const codeResponse = await getCode("code", "RFQModel", "RFQModel")
    methods.setValue("code_edit", codeResponse?.code?.manualoverride)
    try {
      setCurrentRfq(item)
      const response = await fetchRfqReference(item.id)
      methods.reset({
        id: item?.id,
        ref_code: item?.ref_code ? item?.ref_code : "",
        code: item?.code ? item?.code : "",
        materialRequestCode: item.materialRequests?.[0]?.code || "",
        description: response.description || "",
        code_edit: codeResponse?.code?.manualoverride || "",
        items: item.items.map(itm => ({
          description: itm.product?.description || "",
          mr_id: itm.mr_id || "",
          product_id: itm?.product_id || "",
          quantity: itm.quantity || "",
          rfq_id: item?.rfq_id || "",
          price: itm.price || "",
          unit_id: itm?.unit_id || 0,
          row_sub: Number(itm?.quantity || 0) * Number(itm?.price || 0),
        })),
      })
      setCanvasOpen(true)
    } catch (error) {
      console.error("Failed to fetch RFQ reference:", error)
      setCanvasOpen(true)
    }
  }

  const handleApprove = (data) => {
    console.log("handleApprove", data)
    handleModal(data)
  }

  const handleFinalApprove = async data => {
    console.log("handleFinalApprove", data)
    try {
      const formValues = methods.getValues()
      console.log("formValues", formValues)
      const itmArr = formValues.items.map(item => ({
        description: item.description,
        requested_quantity: item.quantity,
        price: item.price,
        material_request_id: item.mr_id,
        // id: item.rfq_id,
        material_id: item.product_id,
        unit_id: item.unit_id,
      }))
      console.log("itmArr", itmArr, formValues?.ref_code, formValues?.items)

      const response = await updateRfqUpdate({
        materialReq: currentRfq.id,
        code: formValues?.code,
        ref_code: formValues?.ref_code,
        // status: 2,
        // description: formValues.description,
        items: itmArr,
        id: formValues.id,
        data,
      })

      toastSuccess(response?.message)
      setCanvasOpen(false)
      setRefresh(refresh + 1)
    } catch (error) {
      toastError(error?.message)
    }
  }

  const handlePriceChange = (value, index) => {
    console.log("handlePriceChange", value, index)
    const qty = methods.watch(`items.${index}.quantity`) || 0
    const rowSub = Number(Number(value) * Number(qty)).toFixed(
      desimalrange || 2
    )

    console.log("Row Sub", rowSub, value, qty)

    methods.setValue(`items[${index}].row_sub`, rowSub)
    setTotalRefresh(totalRefresh + 1)
  }

  const handleReject = async item => {
    try {
      const response = await updateRfqUpdate({
        materialReq: item?.id,
        status: 3,
      })

      toastSuccess(response?.message)
      setCanvasOpen(false)
      setRefresh(refresh + 1)
    } catch (error) {
      toastError(error?.message)
    }
  }

  //   const schema = yup.object().shape({
  //   items: yup.array().of(
  //     yup.object().shape({
  //       price: yup
  //         .number()
  //         .required('Price is required')
  //         .typeError('Price must be a number')
  //         .positive('Price must be positive')
  //     })
  //   ),
  // })
  // Update the schema definition (around line 172)
  const schema = yup.object().shape({
    ref_code: yup.string().required("Reference code is required"),
    items: yup.array().of(
      yup.object().shape({
        price: yup
          .number()
          .required("Price is required")
          .typeError("Price is required")
          .positive("Price must be positive")
          .test("is-zero", "Price cannot be zero", value => value !== 0), // Additional check if needed
      })
    ),
  })

  const { loggedUser } = useSelector(LoginProperties)

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [materialRequest, setMaterialRequest] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [mrno, setMRNo] = useState("")
  const [page, setPage] = useState("")
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [financial, setFinancial] = useState(true)
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)
  // const handleActivate = item => {
  //   const updateStatus = async item => {
  //     const response = await updateSupplierStatus(item)
  //     toastSuccess(response?.message)
  //     setRefresh(refresh + 1)
  //   }
  //   updateStatus(item)
  // }

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleAction = async data => {
    const response = await updateRfqAction(data)
    toastSuccess(response?.message)
    setRefresh(refresh + 1)
    // setRefresh1(refresh1 + 1)
  }

  const handleModal = data => {
    if (data?.status == 2) {
      console.log(`data chk`, data)

      const chkAmt = Array.isArray(data?.item.items)
        ? data?.item.items
          .reduce((sum, i) => sum + Number(i.quantity) * Number(i.price), 0)
          .toFixed(2)
        : 0
      if (chkAmt > 0) {
        setModal(!modal)

        reset({
          materialReq: data?.materialReq,
          status: data?.status,
          ref_code: data?.item?.ref_code,
        })
      } else {
        handleApproveWithDescription(data?.item)
      }
    } else {
      setModal(!modal)

      reset({ ...data })
    }
  }

  const handleReference = item => {
    setModal(!modal)
    reset({
      id: item?.val?.id,
      ref_code: item?.val?.ref_code ? item?.val?.ref_code : "",
    })
  }

  const columns = [
    {
      label: "RFQ No",
      renderCell: item => {
        console.log("llalal", item?.id)
        return (
          <>
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "materialrequest_view"
            ) ? (
              <div
                onClick={() => handleApproveWithDescription(item, item?.id)}
                className="pointer fw-bold"
              >
                <span className="pe-2">{item?.code}</span>
                {item?.status == 2 && (
                  <img src={check} className="est-approve-img" />
                )}
              </div>
            ) : (
              <div>{item?.code}</div>
            )}
          </>
        )
      },
    },
    {
      label: "Supplier Name",
      renderCell: item => item?.vendor?.name,
    },
    {
      label: "Quote Date",
      renderCell: item => moment(item?.created_at).format("DD-MM-YYYY"),
    },
    {
      label: "Quote Reference",
      renderCell: item => (item?.ref_code ? item?.ref_code : "-"),
    },
    {
      label: <div className="text-end pe-5">Total Amount</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {Array.isArray(item.items)
            ? item.items
              .reduce(
                (sum, i) => sum + Number(i.quantity) * Number(i.price),
                0
              )
              .toFixed(2)
            : 0}
        </div>
      ),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.status == 1
                ? "status-draft"
                : item?.status == 2
                  ? "status-active"
                  : item?.status == 3
                    ? "status-inactive"
                    : "status-inactive"
              }`}
          >
            {item?.status == 1
              ? "New"
              : item?.status == 2
                ? "Approved"
                : item?.status == 3
                  ? "Rejected"
                  : "Rejected"}
          </span>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item =>
        fromDashboard ? (
          item?.status == 1 ? (
            <>
              <div>
                <Button
                  color={"primary"}
                  className="btn btn-primary me-2"
                  onClick={() =>
                    handleAction({
                      materialReq: item?.id,
                      status: 2,
                      item: item,
                    })
                  }
                >
                  Approve
                </Button>
                {/* <Button
                  className="hover-button"
                  onClick={() =>
                    handleAction({ materialReq: item?.id, status: 2 })
                  }
                >
                  Reject
                </Button> */}
              </div>
            </>
          ) : (
            <></>
          )
        ) : (
          <>
            <div>
              <span id={`PopoverLegacy-${item?.id}`}>
                <img src={action} alt="" className="pointer" />
              </span>
            </div>
            <UncontrolledPopover
              placement="bottom"
              target={`PopoverLegacy-${item?.id}`}
              trigger="legacy"
            >
              <PopoverBody>
                <div
                  className="table-popup-content"
                  // onClick={() => handleReference({ val: item })}
                  onClick={() => handleApproveWithDescription(item)}
                >
                  {[2, 3].includes(Number(item?.status))
                    ? "View Pricing"
                    : "Update Reference"}
                </div>
                {item?.status == 1 ? (
                  <div
                    className="table-popup-content"
                    // onClick={() => handleApproveWithDescription(item)}
                    // onClick={() =>
                    //   handleModal({
                    //     materialReq: item?.id,
                    //     status: 2,
                    //     item: item,
                    //   })
                    // }
                    onClick={e => {
                      e.preventDefault()
                      setLogoutModal(true)
                      setRefData({
                        materialReq: item?.id,
                        status: 2,
                        item: item,
                      })
                    }}
                  >
                    Approve
                  </div>
                ) : (
                  <></>
                )}
                {item?.status == 1 ? (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      handleModal({ materialReq: item?.id, status: 3 })
                    }
                  >
                    Reject
                  </div>
                ) : (
                  <></>
                )}
                {item?.status == 2 && (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      navigate(`/finance-voucher/add`, {
                        state: item,
                      })
                    }
                  >
                    Convert to PO
                  </div>
                )}
                {/* {item?.status == 1 && ( */}

                {/* )} */}
                {/* <div
                className={`table-popup-content`}
                // onClick={() => handleActivate(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div> */}
              </PopoverBody>
            </UncontrolledPopover>
          </>
        ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }
  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }
  useEffect(() => {
    const fetchMaterialRequest = async () => {
      const response = await searchRfq({
        params: `${status == "0" || status == "1" || status == "2"
            ? `&status=${status}`
            : ""
          }${`&sortOrder=asc`}${search ? `&searchText=${search}` : "&searchText"}${mrno ? `&mr_no=${mrno}` : ""
          }${datefrom ? `&requestdate_from=${datefrom}` : ""}${dateto ? `&requestdate_to=${dateto}` : ""
          }${page ? `&page=${page}` : ""}${`&sizePerPage=16`}${fromDashboard ? `&filter_status=0` : ""
          }${fromDashboard && projectId ? `&project_id=${projectId}` : ""}`,
      })
      // setMaterialRequest(response)
      const newData = response?.data?.data || [];

      setMaterialRequest(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchMaterialRequest()
    // ${`&financial=${financial}`}
  }, [refresh, status, search, mrno, page, datefrom, dateto, financial])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < materialRequest?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [materialRequest, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleRequestChange = id => {
    setMRNo(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  let totalItems = methods.watch("items") || []

  useEffect(() => {
    totalItems = methods.watch("items") || []
  }, [totalRefresh])

  const handleRegistration = async data => {
    console.log("asdada", data)
    try {
      setIsLoading(true)
      const responce = await updateRfqAction(data)
      toastSuccess(responce?.message)
      toggle()
      setRefresh(refresh + 1)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div
        className={`${fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
          }`}
      >
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <Breadcrumbs
                title="Procurement"
                breadcrumbObject={[
                  { title: "Procurement", link: "/procurement" },
                  { title: crumb || "Masters", link: "/procurement" },
                  {
                    title: "RFQs",
                    link: "/procurement-rfq",
                  },
                ]}
              />
            ) : (
              <></>
            )}
            {loggedUser?.permission?.some(
              permissionItem =>
                permissionItem?.name === "materialrequest_create"
            ) && (
                <Link
                  to="/procurement-rfq/add"
                  state={{ menuLabel: crumb }}
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                >
                  {"+ RFQ"}
                </Link>
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <RfqFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleRequestChange={handleRequestChange}
              handleDateChange={handleDateChange}
              handleFinacialChange={handleFinacialChange}
              sampleUrl={"download/suppliers.xlsx"}
              importUrl={"suppliers/import"}
              isImport={false}
              fromDashboard={fromDashboard}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                {materialRequest && (
                  <UpdateTable
                    className="mt-5"
                    nodes={materialRequest?.data?.data}
                    paginate={materialRequest?.data}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    tableWidth="15% 25% 10% 20% 10% 10% 10% "
                    mobileWidth="40% 40% 30% 30% 30% 30% 30%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <ModalHeader className="custom-modal-header">
          <div className="d-flex justify-content-between">
            <h5>Update Reference</h5>{" "}
            <img
              src={closeIcon}
              alt=""
              onClick={toggle}
              width="10"
              role="button"
            />
          </div>
        </ModalHeader>
        <ModalBody>
          <FormProvider {...methods}>
            <Form id={`ev-form`} onSubmit={handleSubmit(handleRegistration)}>
              <Row>
                <Col sm={12}>
                  <FormGroup className="mb-4">
                    <Label>
                      Remarks
                      {/* <span className="mandatory">*</span> */}
                    </Label>
                    <UFInput
                      control={control}
                      placeholder="Enter Remarks"
                      name={"ref_code"}
                      invalid={!!errors.ref_code}
                    />
                    <FormFeedback invalid>
                      {errors.ref_code?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </ModalBody>
        <ModalFooter>
          <LoadingButton
            form={`ev-form`}
            color={"primary"}
            loading={isLoading}
            disabled={isLoading}
            type="submit"
          >
            Update{" "}
          </LoadingButton>
        </ModalFooter>
      </Modal>
      <Offcanvas
        isOpen={canvasOpen}
        toggle={() => setCanvasOpen(false)}
        direction="end"
        className="size-xl"
      >
        <OffcanvasHeader toggle={() => setCanvasOpen(false)}>
          Approve RFQ #{currentRfq?.code}
        </OffcanvasHeader>
        {/* <Col sm={12}> */}
        {/* <FormGroup className="mb-4">
                    <Label>
                      Quote reference no
                      <span className="mandatory">*</span>
                    </Label>
                    <UFInput
                      control={control}
                      placeholder="Enter Quote reference no"
                      name={"ref_code"}
                      invalid={!!errors.ref_code}
                    />
                    <FormFeedback invalid>
                      {errors.ref_code?.message}
                    </FormFeedback>
                  </FormGroup> */}
        {/* </Col> */}
        <OffcanvasBody>
          <FormProvider {...methods}>
            <Form
              id={`lv-form`}
              onSubmit={methods.handleSubmit(handleFinalApprove)}
            >
              {demoStatus !== 12 ? (
                <>
                  <Row>
                    <Col lg="4">
                      <FormGroup className="mb-4">
                        <Label>RFQ No</Label>
                        <UFInput
                          control={methods.control}
                          placeholder="Enter the RFQ No"
                          name={"code"}
                          invalid={!!errors.code}
                          disabled={
                            methods.watch("code_edit") == 0 ||
                              methods.watch("code_edit") == undefined ||
                              [2, 3].includes(Number(itemStatus)) ||
                              demoStatus == 12
                              ? true
                              : false
                          }
                        />
                        <FormFeedback invalid>
                          {errors.code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup className="mb-4">
                        <Label>
                          Quote reference no.
                          <span className="mandatory">*</span>
                        </Label>
                        <UFInput
                          control={methods.control}
                          placeholder="Enter the Quote Reference No"
                          name={"ref_code"}
                          invalid={!!errors.ref_code}
                          disabled={
                            [2, 3].includes(Number(itemStatus)) ||
                            (demoStatus == 12 && true)
                          }
                        />
                        <FormFeedback invalid>
                          {methods.formState.errors.ref_code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                  {methods.watch("items")?.map((item, idx) => (
                    <Row key={idx} className="mb-3">
                      <Col md={4}>
                        {idx === 0 && <Label>Product Description</Label>}
                        <UFInput
                          control={methods.control}
                          name={`items[${idx}].description`}
                          disabled={true}
                        />
                      </Col>
                      <Col md={2}>
                        {idx === 0 && <Label>Quantity</Label>}
                        <UFInput
                          control={methods.control}
                          name={`items[${idx}].quantity`}
                          // disabled={itemStatus == 2 || (demoStatus == 12 && true)}
                          disabled={true}
                        />
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          {idx === 0 && <Label>Price</Label>}
                          <UFInput
                            control={methods.control}
                            name={`items[${idx}].price`}
                            disabled={
                              [2, 3].includes(Number(itemStatus)) ||
                              (demoStatus == 12 && true)
                            }
                            invalid={
                              !!methods.formState.errors?.items?.[idx]?.price
                            }
                            onChange={e => handlePriceChange(e, idx)}
                          />
                          <FormFeedback invalid>
                            {
                              methods.formState.errors?.items?.[idx]?.price
                                ?.message
                            }
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          {idx === 0 && <Label>Sub Price</Label>}
                          <UFInput
                            control={methods.control}
                            name={`items[${idx}].row_sub`}
                            disabled={true}
                            invalid={
                              !!methods.formState.errors?.items?.[idx]?.row_sub
                            }
                          />
                          <FormFeedback invalid>
                            {
                              methods.formState.errors?.items?.[idx]?.row_sub
                                ?.message
                            }
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                  ))}
                  <Row className="edittheamtitle fw-bold">
                    <Col sm={9} className="text-end">
                      Total
                    </Col>
                    <Col sm={3}>
                      {totalItems
                        ?.reduce(
                          (acc, item) => acc + Number(item?.row_sub || 0),
                          0
                        )
                        .toFixed(desimalrange || 2)}

                      {/* <UFInput
                  control={methods.control}
                        name={`sub_total`}
                    value={(methods.watch("items") || [])
                      ?.reduce(
                        (acc, item) => acc + Number(item?.row_sub || 0),
                        0
                      )
                      .toFixed(desimalrange || 2)}
                    disabled={true}
                    readOnly
                  /> */}
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Col lg={12}>
                      <Row className="mb-4">
                        <Col lg={4}>
                          <div>
                            <Label>RFQ No</Label>
                          </div>
                          <div>{currentRfq?.code ? currentRfq?.code : "-"}</div>
                        </Col>
                        <Col lg={4}>
                          <div>
                            <Label>Quote reference no</Label>
                          </div>
                          <div>
                            {currentRfq?.ref_code ? currentRfq?.ref_code : "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12}>
                          <table className="estimation-table mb-4">
                            <thead>
                              <tr>
                                <th>Si No</th>
                                <th>Product Description</th>
                                <th className="text-end pe-1">Quantity</th>
                                <th className="text-end pe-1">Rate</th>
                                <th className="text-end pe-1">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentRfq?.items?.map((item, idx) => {
                                console.log("item", item)
                                return (
                                  <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <div>
                                        <div>
                                          {item?.product?.description || "-"}
                                        </div>

                                        {/* {item?.product?.description &&
                                          item.product.description.length >
                                            30 && (
                                            <UncontrolledPopover
                                              placement="bottom"
                                              target={`PopoverLegacy-${item.id}`}
                                              trigger="legacy"
                                            >
                                              <PopoverBody>
                                                {item.product.description}
                                              </PopoverBody>
                                            </UncontrolledPopover>
                                          )} */}
                                      </div>
                                    </td>

                                    <td className="text-end pe-1">
                                      {item?.quantity || "-"}
                                    </td>
                                    <td className="text-end pe-1">
                                      {item.price || "-"}
                                    </td>
                                    <td className="text-end pe-1">
                                      {Number(item?.quantity || 0) *
                                        Number(item?.price || 0)}
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                      <Row className="edittheamtitle fw-bold">
                        <Col sm={10} className="text-end">
                          Total :
                        </Col>
                        <Col sm={2} className="text-end pe-3">
                          {totalItems
                            ?.reduce(
                              (acc, item) => acc + Number(item?.row_sub || 0),
                              0
                            )
                            .toFixed(desimalrange || 2)}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              )}
              <div className="d-flex justify-content-end mt-3">
                <Button
                  color="secondary"
                  onClick={() => setCanvasOpen(false)}
                  className="me-0"
                >
                  Cancel
                </Button>
                {![2, 3].includes(Number(itemStatus)) && demoStatus != 12 && (
                  <Button color="primary" form={`lv-form`}>
                    Update
                  </Button>
                )}
              </div>
            </Form>
          </FormProvider>
        </OffcanvasBody>
      </Offcanvas>
      <LogoutPopup
        isOpen={logoutModal}
        toggle={() => setLogoutModal(!logoutModal)}
        rfq={true}
        rfqdata={refData}
        handilapprow={handleApprove}
      />
    </React.Fragment>
  )
}

export default RequestForQuote
